'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragItem = exports.DragItem = (_dec = (0, _reactDnd.DragSource)(function (props) {
  return props.type;
}, {
  beginDrag: function beginDrag(props, monitor) {
    props.doAction(props.type, props.data, monitor);
    return { data: props.data };
  },
  endDrag: function endDrag(props, monitor) {
    props.doAction(props.type, props.data, monitor);
  }
}, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(DragItem, _React$PureComponent);

  function DragItem() {
    _classCallCheck(this, DragItem);

    return _possibleConstructorReturn(this, (DragItem.__proto__ || Object.getPrototypeOf(DragItem)).apply(this, arguments));
  }

  _createClass(DragItem, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      if (this.props.isDragging) {
        className += ' j-com-drag';
      }
      return this.props.connectDragSource(_react2.default.createElement(
        'div',
        _extends({ className: className, style: this.props.style }, this.props.htmlFor),
        this.props.children
      ));
    }
  }]);

  return DragItem;
}(_react2.default.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,

  type: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.object.isRequired,
  doAction: _propTypes2.default.func.isRequired,
  connectDragSource: _propTypes2.default.func,
  isDragging: _propTypes2.default.bool,
  children: _propTypes2.default.any,
  htmlFor: _propTypes2.default.object
}, _class2.defaultProps = {
  className: '',

  doAction: function doAction(noop) {
    return noop;
  },
  htmlFor: {}
}, _temp)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/dnd/dragItem.jsx
// module id = 33
// module chunks = 0